import React, { useState, useEffect, useContext } from "react";
import {
  Route,
  Switch,
  withRouter,
  Redirect

} from "react-router-dom";
import classnames from "classnames";

// styles
import useStyles from "./styles";

// components
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";


import Inbox from "../../pages/inbox";

// context
import { useLayoutState } from "../../context/LayoutContext";
import { AuthContext } from "../../context/AuthContext";

function AdminLayout(props) {
  const { getAuthUser, } = useContext(AuthContext)
  const authUser = getAuthUser()

  var classes = useStyles();

  // global
  var layoutState = useLayoutState();

  const RoleRoute = ({ role, roles = [], ...props }) => {
    return !roles.length || roles.includes(role) ? (
      <Route {...props} />
    ) : (
      <Redirect to="/admin/inbox/" />
    );
  };

  return (
    <div className={classes.root}>
      <>
        <Header history={props.history} />
        {/* <Sidebar /> */}
        <div
  className={classnames(classes.content, {
    [classes.contentShift]: layoutState.isSidebarOpened,
  })}
  style={{ padding: 0 }}
>
          {/* <div className={classes.fakeToolbar} /> */}
          <Switch>

        

            <RoleRoute
              path="/admin/inbox/"
              component={Inbox}
              role={authUser.role}
              roles={["superadmin", "admin", "agent"]}
            />
          

          </Switch>
        </div>
      </>
    </div>
  );
}

export default withRouter(AdminLayout);
